export const DEFAULT_STYLING = {
  animation: null,
  rotation: null,
  size: null,
  colorPrimary: '#1E3050',
  colorSecondary: '#1E3050',
  opacityPrimary: 1.0,
  opacitySecondary: 0.4
}
